export default __webpack_public_path__ + "static/media/Punjabi-Kada-Category-List.ec6bfcd5.jpg";